module.exports = __webpack_public_path__ + "img/101.8d8c2b8.png";